// extracted by mini-css-extract-plugin
export default {"siteFooterWrap":"Footer_siteFooterWrap__xSJZy","footer":"Footer_footer__vc4aM","language-selector":"Footer_language-selector__KmQA9"};